<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Información de estados</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="alert-text text-warning text-start">
      <h4>1. En trámite</h4>
      <h4>2. Con observaciones</h4>
      <h4>3. Rechazado</h4>
      <h4>4. Aprobado</h4>
    </div>
  </mat-expansion-panel>
</mat-accordion>
